import moment from 'moment';

export const isSelected = (day, selectedDate) => (
  !!selectedDate && day.isSame(selectedDate, 'day')
);

export const isBeforeToday = (day, today = moment()) => (
  day.isBefore(moment(today), 'day')
);

export const isDateClosed = (date, closedDates = []) => (
  closedDates.includes(date.format('YYYY-MM-DD'))
);

export const isWeekdayClosed = (date, closedWeekdays = {}) => (
  !!closedWeekdays[date.format('dddd')]
);

export const isClosed = (date, closedDates = [], closedWeekdays = {}) => (
  isDateClosed(date, closedDates) || isWeekdayClosed(date, closedWeekdays)
);

export const getClosedMessage = (date, closedDates = [], closedWeekdays = {}) => {
  if (isDateClosed(date, closedDates)) {
    return 'Please choose another day. None of your selected stations are open on this day.';
  } else {
    return closedWeekdays[date.format('dddd')];
  }
};

export const isOutboundDateDisabled = (day, closedDates = [], closedWeekdays = {}) => (
  isBeforeToday(day) || isClosed(day, closedDates, closedWeekdays)
);

export const isBeforeMinDeparture = (day, minDeparture) => (
  day.isBefore(moment(minDeparture), 'day')
);

export const isReturnDateDisabled = (day, minDeparture, closedWeekdays = {}) => (
  isBeforeMinDeparture(day, minDeparture) || isWeekdayClosed(day, closedWeekdays)
);

export const hasDateWithFlight = (day, datesWithFlights = []) => {
  const date = day.format('YYYY-MM-DD');
  return datesWithFlights instanceof Set ? datesWithFlights.has(date) : datesWithFlights.includes(date);
};
